import type { SVGProps } from 'react';

const SvgKlaviyoSwag = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="smart-send-time">
      <path d="M31.78 20.76a.76.76 0 0 0-.65-.38h-14.2a.76.76 0 0 0-.75.75v9.81a.76.76 0 0 0 .75.75h14.2a.76.76 0 0 0 .65-.37.77.77 0 0 0 0-.75L29.25 26l2.54-4.54a.75.75 0 0 0-.01-.7Zm-4 4.91a.73.73 0 0 0 0 .73l2.11 3.79H17.68v-8.31h12.17Z" />
      <path d="M25 .53a.77.77 0 0 0-.53-.22h-4.24a.76.76 0 0 0-.71.49A3.8 3.8 0 0 1 16 3.25 3.8 3.8 0 0 1 12.48.8a.76.76 0 0 0-.71-.49H7.55A.77.77 0 0 0 7 .53L.34 7.22a.75.75 0 0 0 0 1.06l4.39 4.39a.75.75 0 0 0 1.06 0l2.41-2.41v13.58a.75.75 0 0 0 .75.75h4.84v-1.5H9.7V8.45a.74.74 0 0 0-.46-.69.75.75 0 0 0-.82.16l-3.16 3.16-3.33-3.33 5.94-5.94h3.41A5.31 5.31 0 0 0 16 4.75a5.31 5.31 0 0 0 4.72-2.94h3.42l5.93 5.94-3.33 3.33-3.16-3.16a.74.74 0 0 0-.81-.16.75.75 0 0 0-.47.69v10.14h1.5v-8.33l2.41 2.41a.75.75 0 0 0 1.06 0l4.39-4.39a.74.74 0 0 0 0-1.06Z" />
    </g>
  </svg>
);

export default SvgKlaviyoSwag;
